import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from 'src/app/services/http.service';
import { FlagAnalysis, GetItemsParams, ReportListData } from './reports.model';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {
  constructor(private apiService: HttpService) {}

  /* NOTE : For Other reports */
  getReports<T>(param: GetItemsParams, reportName: string): Observable<ReportListData<T>> {
    let params = this.apiService.Params;
    params = params.set('sortColumn', param.sortColumn);
    params = params.set('sortOrder', param.sortOrder);
    params = params.set('clinicId', param.clinicId ? param.clinicId : 0);
    params = params.set('fromDate', param.fromDate);
    params = params.set('toDate', param.toDate);
    return this.apiService.getData<any>(`Report/${reportName}`, params);
  }

  /* NOTE : For specific Flag Analysis */
  getReportsFA<T>(param: GetItemsParams, reportName: string): Observable<ReportListData<T>> {
    let params = this.apiService.Params;
    params = params.set('sortColumn', param.sortColumn);
    params = params.set('sortOrder', param.sortOrder);
    params = params.set('clinicId', param.clinicId ? param.clinicId : 0);
    params = params.set('fromDate', param.fromDate);
    params = params.set('toDate', param.toDate);
    params = params.set('appointmentType', param.appointmentType || '1');
    return this.apiService.getData<any>(`Report/${reportName}`, params);
  }

  exportReport(param: GetItemsParams, reportName: string): Observable<any> {
    let params = this.apiService.Params;
    params = params.set('clinicId', param.clinicId ? param.clinicId : 0);
    params = params.set('fromDate', param.fromDate);
    params = params.set('toDate', param.toDate);
    return this.apiService.getData<any>(`Report/Export${reportName}`, params);
  }
  exportReportFA(param: GetItemsParams, reportName: string): Observable<any> {
    let params = this.apiService.Params;
    params = params.set('clinicId', param.clinicId ? param.clinicId : 0);
    params = params.set('fromDate', param.fromDate);
    params = params.set('toDate', param.toDate);
    params = params.set('appointmentType', param.appointmentType || '1');
    return this.apiService.getData<any>(`Report/Export${reportName}`, params);
  }
}
